export const WALMART_PRODUCT_INFORMATION = {
  moduleName: 'walmartProductInformation',
  moduleDisplayName: 'Walmart Production Information',
};
